import React from "react";
import JoinRaces from "./components/JoinRaces";
import ComingSoon from "./components/ComingSoon";
import Watch from "./components/watch/Watch";
import Wizard from "./components/wizard/Wizard"; // Add Wizard component import

const routes = [
  {
    path: "/",
    element: <JoinRaces />,
  },
  {
    path: "/join-races",
    element: <JoinRaces />,
  },
  {
    path: "/race-wizard", // Point to the wizard component route
    element: <Wizard />, // Use the Wizard component
  },
  {
    path: "/watch",
    element: <Watch />,
  },
  {
    path: "/faq",
    element: <ComingSoon />,
  },
  {
    path: "/support",
    element: <ComingSoon />,
  },
];

export default routes;
